/* eslint-disable */
import Vue from 'vue'
import App from './App.vue'
import store from './store'
import router from './router'
import { Formio } from 'formiojs'
import * as VueGoogleMaps from 'vue2-google-maps'
import './components'
import './permission'
import './firebase'
import './api/inspirados'
import Vuelidate from 'vuelidate'
import BootstrapVue, { IconsPlugin } from 'bootstrap-vue'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faArrowCircleLeft } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import VuePapaParse from 'vue-papa-parse'

Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyCfa61txsFZ0kX4KRcEg8uK6z3-5OU8HYM',
    libraries: 'places' // necessary for places input
  }
})
Vue.use(BootstrapVue)
library.add(faArrowCircleLeft)
Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.use(IconsPlugin)
Vue.prototype.formio = Formio
Vue.use(Vuelidate)
Vue.use(VuePapaParse)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App),
  components: { App }
})
